"use strict";

var _taggedTemplateLiteral = require("/Users/laurens/apps/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _slicedToArray = require("/Users/laurens/apps/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Users/laurens/apps/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/laurens/apps/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/laurens/apps/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMarkdownForHtmlNodes = exports.Visitor = void 0;

var nodes_1 = require("./nodes");

var utilities_1 = require("./utilities");

var translator_1 = require("./translator");

var config_1 = require("./config"); // endregion

/* ****************************************************************************************************************** */
// region: Visitor

/* ****************************************************************************************************************** */

/**
 * Properties & methods marked public are designated as such due to the fact that we may add middleware / transformer
 * support in the future
 */


var Visitor = /*#__PURE__*/function () {
  function Visitor(instance, rootNode, fileName) {
    _classCallCheck(this, Visitor);

    this.instance = instance;
    this.rootNode = rootNode;
    this.fileName = fileName;
    this.nodeMetadata = new Map();
    this.urlDefinitions = [];
    this.result = {
      text: '',
      trailingNewlineStats: {
        whitespace: 0,
        newLines: 0
      }
    };
    this.options = instance.options;
    this.optimizeTree(rootNode);
    this.visitNode(rootNode);
  }
  /* ********************************************************* */
  // region: Methods

  /* ********************************************************* */


  _createClass(Visitor, [{
    key: "addOrGetUrlDefinition",
    value: function addOrGetUrlDefinition(url) {
      var id = this.urlDefinitions.findIndex(function (u) {
        return u === url;
      });
      if (id < 0) id = this.urlDefinitions.push(url) - 1;
      return id + 1;
    }
  }, {
    key: "appendResult",
    value: function appendResult(s, startPos, spaceIfRepeatingChar) {
      if (!s && startPos === undefined) return;
      var result = this.result;
      if (startPos !== undefined) result.text = result.text.substr(0, startPos);
      result.text += (spaceIfRepeatingChar && result.text.slice(-1) === s[0] ? ' ' : '') + s;
      result.trailingNewlineStats = (0, utilities_1.getTrailingWhitespaceInfo)(result.text);
    }
  }, {
    key: "appendNewlines",
    value: function appendNewlines(count) {
      var newLines = this.result.trailingNewlineStats.newLines;
      this.appendResult('\n'.repeat(Math.max(0, +count - newLines)));
    } // endregion

    /* ********************************************************* */
    // region: Internal Methods

    /* ********************************************************* */

    /**
     * Optimize tree, flagging nodes that have usable content
     */

  }, {
    key: "optimizeTree",
    value: function optimizeTree(node) {
      (0, utilities_1.perfStart)('Optimize tree');
      var translators = this.instance.translators;

      (function visit(node) {
        var res = false;

        if ((0, nodes_1.isTextNode)(node) || (0, nodes_1.isElementNode)(node) && config_1.contentlessElements.includes(node.tagName)) {
          res = true;
        } else {
          var childNodes = (0, utilities_1.getChildNodes)(node);

          if (!childNodes.length) {
            var translator = translators[node.tagName];
            if ((translator === null || translator === void 0 ? void 0 : translator.preserveIfEmpty) || typeof translator === 'function') res = true;
          } else {
            var _iterator = _createForOfIteratorHelper(childNodes),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var child = _step.value;
                if (!res) res = visit(child);else visit(child);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }

        return node.preserve = res;
      })(node);

      (0, utilities_1.perfStop)('Optimize tree');
    }
    /**
     * Apply escaping and custom replacement rules
     */

  }, {
    key: "processText",
    value: function processText(text, metadata) {
      var res = text;
      if (!(metadata === null || metadata === void 0 ? void 0 : metadata.preserveWhitespace)) res = res.replace(/\s+/g, ' ');
      if (metadata === null || metadata === void 0 ? void 0 : metadata.noEscape) return res;
      var _this$options = this.options,
          lineStartEscape = _this$options.lineStartEscape,
          globalEscape = _this$options.globalEscape,
          textReplace = _this$options.textReplace;
      res = res.replace(globalEscape[0], globalEscape[1]).replace(lineStartEscape[0], lineStartEscape[1]);
      /* If specified, apply custom replacement patterns */

      if (textReplace) {
        var _iterator2 = _createForOfIteratorHelper(textReplace),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                pattern = _step2$value[0],
                r = _step2$value[1];

            res = res.replace(pattern, r);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      return res;
    }
  }, {
    key: "visitNode",
    value: function visitNode(node, textOnly, metadata) {
      var _a, _b, _c, _d;

      var _e, _f;

      var result = this.result;
      if (!node.preserve) return;
      /* Handle text node */

      if ((0, nodes_1.isTextNode)(node)) {
        if (node.wholeText) {
          (_a = (_e = node).text) !== null && _a !== void 0 ? _a : _e.text = node.wholeText;
          (_b = (_f = node).trimmedText) !== null && _b !== void 0 ? _b : _f.trimmedText = (0, utilities_1.trimNewLines)(node.wholeText);
        }

        return node.isWhitespace && !(metadata === null || metadata === void 0 ? void 0 : metadata.preserveWhitespace) ? !result.text.length || result.trailingNewlineStats.whitespace > 0 ? void 0 : this.appendResult(' ') : this.appendResult(this.processText((metadata === null || metadata === void 0 ? void 0 : metadata.preserveWhitespace) ? node.text : node.trimmedText, metadata));
      }

      if (textOnly || !(0, nodes_1.isElementNode)(node)) return;
      /* Handle element node */

      var translatorCfgOrFactory = (metadata === null || metadata === void 0 ? void 0 : metadata.translators) ? metadata.translators[node.tagName] : this.instance.translators[node.tagName];
      /* Update metadata with list detail */

      switch (node.tagName) {
        case 'UL':
        case 'OL':
          metadata = Object.assign(Object.assign({}, metadata), {
            listItemNumber: 0,
            listKind: node.tagName,
            indentLevel: ((_c = metadata === null || metadata === void 0 ? void 0 : metadata.indentLevel) !== null && _c !== void 0 ? _c : -1) + 1
          });
          break;

        case 'LI':
          if ((metadata === null || metadata === void 0 ? void 0 : metadata.listKind) === 'OL') metadata.listItemNumber = ((_d = metadata.listItemNumber) !== null && _d !== void 0 ? _d : 0) + 1;
          break;

        case 'PRE':
          metadata = Object.assign(Object.assign({}, metadata), {
            preserveWhitespace: true
          });
          break;

        case 'TABLE':
          metadata = Object.assign(Object.assign({}, metadata), {
            tableMeta: {
              node: node
            }
          });
      }

      if (metadata) this.nodeMetadata.set(node, metadata); // If no translator for element, visit children

      if (!translatorCfgOrFactory) {
        var _iterator3 = _createForOfIteratorHelper((0, utilities_1.getChildNodes)(node)),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var child = _step3.value;
            this.visitNode(child, textOnly, metadata);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        return;
      }
      /* Get Translator Config */


      var cfg;
      var ctx;

      if (!(0, translator_1.isTranslatorConfig)(translatorCfgOrFactory)) {
        ctx = (0, translator_1.createTranslatorContext)(this, node, metadata, translatorCfgOrFactory.base);
        cfg = Object.assign(Object.assign({}, translatorCfgOrFactory.base), translatorCfgOrFactory(ctx));
      } else cfg = translatorCfgOrFactory; // Skip and don't check children if ignore flag set


      if (cfg.ignore) return;
      /* Update metadata if needed */

      if (cfg.noEscape && !(metadata === null || metadata === void 0 ? void 0 : metadata.noEscape)) {
        metadata = Object.assign(Object.assign({}, metadata), {
          noEscape: cfg.noEscape
        });
        this.nodeMetadata.set(node, metadata);
      }

      if (cfg.childTranslators && cfg.childTranslators !== (metadata === null || metadata === void 0 ? void 0 : metadata.translators)) {
        metadata = Object.assign(Object.assign({}, metadata), {
          translators: cfg.childTranslators
        });
        this.nodeMetadata.set(node, metadata);
      }

      var startPosOuter = result.text.length;
      /* Write opening */

      if (cfg.surroundingNewlines) this.appendNewlines(+cfg.surroundingNewlines);
      if (cfg.prefix) this.appendResult(cfg.prefix);
      /* Write inner content */

      if (typeof cfg.content === 'string') this.appendResult(cfg.content, void 0, cfg.spaceIfRepeatingChar);else {
        var startPos = result.text.length; // Process child nodes

        var _iterator4 = _createForOfIteratorHelper((0, utilities_1.getChildNodes)(node)),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _child = _step4.value;
            this.visitNode(_child, cfg.recurse === false, metadata);
          }
          /* Apply translator post-processing */

        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        if (cfg.postprocess) {
          var postRes = cfg.postprocess(Object.assign(Object.assign({}, ctx || (0, translator_1.createTranslatorContext)(this, node, metadata)), {
            content: result.text.substr(startPos)
          })); // If remove flag sent, remove / omit everything for this node (prefix, newlines, content, postfix)

          if (postRes === translator_1.PostProcessResult.RemoveNode) {
            if (node.tagName === 'LI' && (metadata === null || metadata === void 0 ? void 0 : metadata.listItemNumber)) --metadata.listItemNumber;
            return this.appendResult('', startPosOuter);
          }

          if (typeof postRes === 'string') this.appendResult(postRes, startPos, cfg.spaceIfRepeatingChar);
        }
      }
      /* Write closing */

      if (cfg.postfix) this.appendResult(cfg.postfix);
      if (cfg.surroundingNewlines) this.appendNewlines(+cfg.surroundingNewlines);
    }
  }]);

  return Visitor;
}();

exports.Visitor = Visitor; // endregion

/* ****************************************************************************************************************** */
// region: Utilities

/* ****************************************************************************************************************** */

function getMarkdownForHtmlNodes(instance, rootNode, fileName) {
  (0, utilities_1.perfStart)('walk');
  var visitor = new Visitor(instance, rootNode, fileName);
  var result = visitor.result.text;
  (0, utilities_1.perfStop)('walk');
  /* Post-processing */
  // Add link references, if set

  if (instance.options.useLinkReferenceDefinitions) {
    if (/[^\r\n]/.test(result.slice(-1))) result += '\n';
    visitor.urlDefinitions.forEach(function (url, idx) {
      result += "\n[".concat(idx + 1, "]: ").concat(url);
    });
  } // Fixup repeating newlines


  var maxConsecutiveNewlines = instance.options.maxConsecutiveNewlines;
  if (maxConsecutiveNewlines) result = result.replace(new RegExp(String.raw(_templateObject || (_templateObject = _taggedTemplateLiteral(["(?:\r?\ns*)+((?:\r?\ns*){", "})"], ["(?:\\r?\\n\\s*)+((?:\\r?\\n\\s*){", "})"])), maxConsecutiveNewlines), 'g'), '$1');
  return (0, utilities_1.trimNewLines)(result);
}

exports.getMarkdownForHtmlNodes = getMarkdownForHtmlNodes; // endregion